import gql from 'graphql-tag';

export const RIGHT_FRAGMENT = gql`
  fragment RightInfo on RoleRight {
    id
    title
    constantCode
  }
`;
